import { gql } from 'apollo-boost';

export const ATTACH_MESSAGES_TO_THREAD = gql`
    mutation($data: AttachMessagesToThreadInput!) {
        attachMessagesToThread(data: $data)
    }
`;
